import React from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import styles from './styles/ReportingTable.module.scss';

import { OmaLummeApp, ConsumptionApp } from '../../../omaLummeContext';

// Utils.
import { roundNumber, setPriceFormat } from '../../../utils/billing';
import { capitalizeFirstLetter, lessThan0Point01 } from '../../../utils/consumption';
import { fi } from 'react-day-picker/locale';

type ReportingTableProps = {
  productionContract: boolean;
};

export const ReportingTable: React.FunctionComponent<ReportingTableProps> = (props: ReportingTableProps) => {
  const { t } = useTranslation();

  const { users } = OmaLummeApp.useState();
  const { activeFilter, graphData, type } = ConsumptionApp.useState();
  const { showComparisonData, contractIsNoPrice } = ConsumptionApp.useState();
  const { productionContract } = props;

  const customerType = users.activeUser.customerType;

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>{t('consumption:consumption.csv-timestamp')}</th>
          <th>{t(`consumption:consumption.csv-${productionContract ? 'production' : 'consumption'}`)}</th>
          {customerType === 'private' && !productionContract && !contractIsNoPrice && <th>{t('consumption:consumption.csv-costWithVat')}</th>}
          {!contractIsNoPrice && (customerType === 'business' || productionContract) && <th>{t('consumption:consumption.csv-costWithoutVat')}</th>}
          {showComparisonData && <th>{t('consumption:consumption.csv-comparison')}</th>}
          {showComparisonData && <th>{t('consumption:consumption.csv-comparisonChange')}</th>}
          {type === 'single' && <th>{t('consumption:consumption.csv-temperature')}</th>}
          {type === 'single' && <th>{t('consumption:consumption.csv-spot')}</th>}
        </tr>
      </thead>
      <tbody>
        {graphData &&
          graphData.map((item) => {
            let change: boolean | number = false;

            if (showComparisonData && item.comparisonConsumption && item.consumption) {
              change = ((item.consumption - item.comparisonConsumption) / item.comparisonConsumption) * 100;
            }

            let timeFormat = 'iiiiii dd.MM.yyyy';
            if (activeFilter === 'year') {
              timeFormat = 'LLLL yyyy';
            }

            return (
              <tr key={item.time}>
                <td>
                  {capitalizeFirstLetter(format(new Date(item.time || new Date()), timeFormat, { locale: fi }))}{' '}
                  {activeFilter === 'day' &&
                    `${t(`consumption:consumption.reportingGraph-timeAt`)} ${format(new Date(item.time || new Date()), 'HH:mm', { locale: fi })}`}
                </td>
                <td>{item.consumption ? lessThan0Point01(item.consumption) : 0} kWh</td>
                {customerType === 'private' && !productionContract && <td>{item.costWithVat ? lessThan0Point01(item.costWithVat) : 0} €</td>}
                {!contractIsNoPrice && (customerType === 'business' || productionContract) && (
                  <td>{item.costWithoutVat ? lessThan0Point01(item.costWithoutVat) : 0} €</td>
                )}
                {showComparisonData && item.comparisonConsumption && <td>{setPriceFormat(roundNumber(item.comparisonConsumption))} kWh</td>}
                {change && (
                  <td>
                    {change > 0 ? '+' : ''}
                    {change.toFixed(0)} %
                  </td>
                )}
                {type === 'single' && <td>{item.temperature !== undefined ? `${roundNumber(item.temperature, false)} °C` : ''}</td>}
                {type === 'single' && (
                  <td>{item.spotPrice !== undefined ? `${roundNumber(item.spotPrice, false)} ${t(`consumption:nordPoolGraph.spotUnit`)}` : ''}</td>
                )}
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};
